import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom';
import debounce from "lodash.debounce";
import TooltipMaterial from "@material-ui/core/Tooltip";
import UploadDummy from 'web/assets/images/UploadDummy.png'
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineSearch, } from "react-icons/ai";
import Spinner from 'web/components/Spinner'
import { SearchWrapper } from '../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import styled from "styled-components";
import { storeAdminDetails, logoutAdmin, getQuoteListApi, markQuote } from 'redux/actions/admin';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { OrderDetailsWrapper, NotesModalWrapper, DateWrapper } from './QuoteStyled'
import { Table, Modal, ModalBody } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import EditIcon from "web/assets/svg/EditUnderlineIcon"
import NotesModal from './NotesModal';
import YesNoModal from 'web/components/YesNoModal';
import AlertModal from 'web/components/AlertModal';
import DatePicker from 'web/components/DatePicker';

function Quotes({ scrollTop }) {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [accordionOpenIndex, setAccordionOpenIndex] = useState()
    const [finalData, setFinalData] = useState()
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const token = localStorage.getItem("token")
    const [notesModal, setNotesModal] = useState(false)
    const [editComment, setNotesComment] = useState([])
    const [editFlag, setEditFlag] = useState(false)

    const [selectedQuote, setSelectedQuote] = useState(false);
    const [yesNomodal, setYesNoModal] = useState(false);
    const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
    const [yesNoModalContent, setYesNoModalContent] = useState("");
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState("");
    const [alertType, setAlertType] = useState();

    let toDateGetQuote = new Date();
    let fromDateGetQuote = new Date();
    fromDateGetQuote.setMonth(fromDateGetQuote.getMonth() - 2)

    const [startDateValue, setStartDateValue] = useState(moment(fromDateGetQuote).format("MM/DD/YYYY"))
    const [endDateValue, setEndDateValue] = useState(moment(toDateGetQuote).format("MM/DD/YYYY"))

    const [userStateValues, setUserStateValues] = useState({
        fromDate: moment(fromDateGetQuote).format("MM/DD/YYYY"),
        toDate: moment(toDateGetQuote).format("MM/DD/YYYY"),
    });

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        let data = {
            size: 10,
            number: page,
            fromDate: userStateValues.fromDate && moment(userStateValues.fromDate).format('YYYY-MM-DD'),
            toDate: userStateValues.toDate && moment(userStateValues.toDate).add(1, 'days').format('YYYY-MM-DD'),
            sort: "DESC",
            searchBy: tableSearch
        }
        fetchQuotesList(data);
    }, []);

    const fetchQuotesList = async (dataVal) => {
        let response = '';
        let data = dataVal
        response = await dispatch(getQuoteListApi(data, token));
        if (response.data?.status === 'SUCCESS') {
            if (response.data?.payload) {
                let pageData = JSON.parse(JSON.stringify(response.data?.payload))
                setFinalData(pageData?.content)
                setPageCount(pageData?.totalPages)
            }
            else setFinalData([])
        } else if (response.message === 'Request failed with status code 409') {
            setFinalData([])
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            }
        }
    };

    let headerArr = [
        { title: 'Quote Submitted Date' },
        { title: 'Location Name' },
        { title: 'Contact Name' },
        { title: 'Email' },
        { title: 'City, State' },
        { title: 'Zip' },
        { title: 'Quantity, Order Type' },
        { title: 'Delivery/Pick Up' },
        { title: 'Delivery/Pick Up Date' },
        { title: 'Admin Notes' },
        { title: 'Status' },
        { title: "" }
    ];

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }

    const handleSearchChange = (event) => {
        scrollTop()
        setAccordionFunction()
        setPage(0)
        const searchTerm = event.target.value;
        setTableSearch(searchTerm);
        let data = {
            size: 10,
            number: 0,
            fromDate: userStateValues.fromDate && moment(userStateValues.fromDate).format('YYYY-MM-DD'),
            toDate: userStateValues.toDate && moment(userStateValues.toDate).add(1, 'days').format('YYYY-MM-DD'),
            sort: "DESC",
            searchBy: searchTerm
        }
        debouncedSearch(data);
    };

    const debouncedSearch = useCallback(debounce((data) => fetchQuotesList(data), 500), []);

    const callFetchApiFunc = (e, value) => {
        scrollTop()
        setAccordionFunction()
        setPage(value - 1);
        let data = {
            size: 10,
            number: value - 1,
            fromDate: userStateValues.fromDate && moment(userStateValues.fromDate).format('YYYY-MM-DD'),
            toDate: userStateValues.toDate && moment(userStateValues.toDate).add(1, 'days').format('YYYY-MM-DD'),
            sort: "DESC",
            searchBy: tableSearch
        }
        fetchQuotesList(data)
    }

    const setAccordionFunction = index => {
        setAccordionOpenIndex(index)
    }

    const downloadPdfDocument = async (imagePath) => {
        const fileUrl = process.env.REACT_APP_PT_PLUS_API_URL + 'ptms/s3/get_file/' + imagePath
        window.open(fileUrl)
    }

    const specificationFiles = (spectItem) => {
        return (
            <div className="row mb-1">
                <TooltipMaterial
                    placement="top"
                    arrow
                    title={spectItem?.fileName}
                    enterTouchDelay={0}
                >
                    <UploadSpec
                        className="upload col-12"
                        onClick={() => {
                            downloadPdfDocument(spectItem?.fileName)
                        }}
                    >
                        <img
                            src={UploadDummy}
                            alt="upload Dummy"
                        />
                        <span>{spectItem?.orignalFileName}</span>
                    </UploadSpec>
                </TooltipMaterial>
            </div>
        );
    }

    const orderType = (items) => {
        let totalQuantity = items.quantity
        let material = items?.material?.toUpperCase()

        let condition
        if (items?.isUsed) {
            condition = 'USED'
        } else if (items?.isNew) {
            condition = 'NEW'
        } else if (items?.isCombo) {
            condition = 'COMBO'
        }

        let palletType, moisture, size, grade, LWH

        if (material === 'WOOD') {
            palletType = items.commodity?.commodityName?.toUpperCase()
            if (items.moistureContent) moisture = items.moistureContent
            if (items.sizeWiseGrad) size = items.sizeWiseGrad
            if (items.grade) grade = items.grade
        }
        if (items?.commodityDim?.length) {
            const length = items?.commodityDim?.length
            const width = items?.commodityDim?.width
            const height = items?.commodityDim?.height
            LWH = length + "x" + width + "x" + height
        }
        let orderTypeText
        orderTypeText = totalQuantity
        if (size) orderTypeText = orderTypeText + ', ' + size
        if (LWH) orderTypeText = orderTypeText + ', ' + LWH
        if (grade) orderTypeText = orderTypeText + ', ' + grade
        if (moisture) orderTypeText = orderTypeText + ', ' + moisture
        if (palletType) orderTypeText = orderTypeText + ', ' + palletType
        if (condition) orderTypeText = orderTypeText + ' - ' + condition
        return orderTypeText
    }

    const vehiclePref = (vehicle) => {
        let vehicleList = []
        if (vehicle.includes('FLAT_BED')) vehicleList.push('Flatbed')
        if (vehicle.includes('VAN')) vehicleList.push('Enclosed Trailer')
        if (vehicle.includes('STRAIGHT')) vehicleList.push('Straight Truck')
        if (vehicleList.length > 0) return vehicleList.join(', ')
        else return ''
    }

    const markQuoteAction = async (selectedQuote) => {
        let data = {
            id: selectedQuote?.quoteId,
            markCompleted: true
        }
        const token = localStorage.getItem("token");
        let response = await dispatch(markQuote(data, token));
        if (response.status === "SUCCESS") {
            setAlertModalContent(response?.message);
            setAlertModal(!alertModal);
            setAlertType("success");
        } else {
            if (response?.statusCode === 401) {
                adminLogout();
            } else {
                setAlertModalContent(response?.message);
                setAlertModal(true);
            }
        }
    };

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('QUOTES'))) ?
                <div>
                    {loaderVisible && <Spinner />}
                    <div>
                        <TableWrapper>
                            <Heading>
                                <h3>Quotes</h3>

                                <div className='d-flex flex-wrap flex-sm-nowrap'>
                                    <DateWrapper>
                                        <label>From</label>
                                        <DatePicker
                                            name="fromDateGetQuote"
                                            placeholderText=""
                                            maxDOBirth={userStateValues.toDate}
                                            value={userStateValues.fromDate}
                                            inputValue={startDateValue}
                                            callBackFun={(date, value) => {
                                                setStartDateValue(value)
                                                if (moment(date, moment.ISO_8601, true).isValid()) {
                                                    setUserStateValues((prevState) => ({
                                                        ...prevState,
                                                        ["fromDate"]: moment(date).format("MM/DD/YYYY"),
                                                    }));
                                                } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                    setUserStateValues((prevState) => ({
                                                        ...prevState,
                                                        ["fromDate"]: null,
                                                    }));
                                                }
                                            }}
                                        />
                                    </DateWrapper>
                                    <DateWrapper>
                                        <label>To</label>
                                        <DatePicker
                                            name="toDateGetQuote"
                                            placeholderText=""
                                            minDOBirth={userStateValues.fromDate}
                                            value={userStateValues.toDate}
                                            inputValue={endDateValue}
                                            callBackFun={(date, value) => {
                                                setEndDateValue(value)
                                                if (moment(date, moment.ISO_8601, true).isValid()) {
                                                    setUserStateValues((prevState) => ({
                                                        ...prevState,
                                                        ["toDate"]: moment(date).format("MM/DD/YYYY"),
                                                    }));
                                                } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                    setUserStateValues((prevState) => ({
                                                        ...prevState,
                                                        ["toDate"]: null,
                                                    }));
                                                }
                                            }}
                                        />
                                    </DateWrapper>
                                    <button className='button-style-green'
                                        onClick={(e) => callFetchApiFunc(e, 1)}>
                                        Submit
                                    </button>
                                    <div className='vertical-line'></div>
                                    <SearchWrapper>
                                        <input type="text" placeholder='Search' value={tableSearch}
                                            onChange={handleSearchChange} />
                                        <AiOutlineSearch />
                                    </SearchWrapper>

                                </div>
                            </Heading>

                            <OrderDetailsWrapper>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            {headerArr.map((items, index) => (
                                                index === 10 ?
                                                    <th key={index} style={{ textAlign: "center" }}>
                                                        {items.title}
                                                    </th> :
                                                    <th key={index}>
                                                        {items.title}
                                                    </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            finalData && finalData.map((items, index) => (
                                                <>
                                                    <tr key={index} className='user-list-table-styles'>
                                                        <td>{items.createdAt ? moment(items.createdAt).format('MM/DD/YYYY') : ''}</td>
                                                        <td>{items.locationName}</td>
                                                        <td>{items.contactName}</td>
                                                        <td>{items.email}</td>
                                                        <td>{`${items.city?.trim()}, ${stateConvert(items.state?.trim()) || items.state?.trim()}`}</td>
                                                        <td>{items.zip}</td>
                                                        <td>{orderType(items)}</td>
                                                        <td>{items.isDelivery ? 'Delivery' : 'Pick Up'}</td>
                                                        <td>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</td>
                                                        <td title={items.notes ? items.notes : ''} style={{ minWidth: "50px" }}>
                                                            <span onClick={() => {
                                                                setNotesModal(true)
                                                                setNotesComment(items)
                                                            }}><EditIcon /></span>
                                                            {items?.notes && items?.notes.substring(0, 10)}
                                                            {items?.notes && items?.notes.length > 10 && <span>...</span>}
                                                        </td>

                                                        <td style={{ textAlign: "center", minWidth: "150px" }}>
                                                            {items?.markCompleted ? (
                                                                <button style={{
                                                                    padding: "5px 15px",
                                                                    background: "#61AE24",
                                                                    borderRadius: "4px",
                                                                    border: "none",
                                                                    fontFamily: 'Latoregular',
                                                                    fontStyle: "normal",
                                                                    fontWeight: 400,
                                                                    fontSize: "15px",
                                                                    lineHeight: "18px",
                                                                    color: "#FFFFFF",
                                                                    textAlign: "center",
                                                                    cursor: 'default'
                                                                }}
                                                                    onClick={() => {
                                                                    }}
                                                                >DONE</button>
                                                            ) : (
                                                                <button style={{
                                                                    padding: "5px 15px",
                                                                    background: "#fff",
                                                                    borderRadius: "4px",
                                                                    border: "1px solid",
                                                                    fontFamily: 'Latoregular',
                                                                    fontStyle: "normal",
                                                                    fontWeight: 400,
                                                                    fontSize: "15px",
                                                                    lineHeight: "18px",
                                                                    color: "black",
                                                                    textAlign: "center"
                                                                }}
                                                                    onClick={() => {
                                                                        setYesNoModalContent("Do you want to mark the quote as done?")
                                                                        yesNoToggleModal()
                                                                        setSelectedQuote(items)
                                                                    }}>Mark DONE</button>
                                                            )}{" "}
                                                        </td>
                                                        <td className='expand-collapse-class'>
                                                            {(accordionOpenIndex === index) ?
                                                                <h4 onClick={() => setAccordionFunction()}><i></i></h4>
                                                                : <h5 onClick={() => setAccordionFunction(index)}><i></i></h5>
                                                            }
                                                        </td>
                                                    </tr>
                                                    {accordionOpenIndex === index &&
                                                        <>
                                                            <tr className='order-details-wrapper'>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Material</h6>
                                                                        <p style={{ whiteSpace: 'nowrap' }}>{items.material?.toUpperCase()}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Phone Number</h6>
                                                                        <p style={{ whiteSpace: 'nowrap' }}>{items.phoneNumber}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Appointment From</h6>
                                                                        <p>{items.appointmetWindowBegin?.substring(0, 5)}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Appointment To</h6>
                                                                        <p>{items.appointmetWindowEnd?.substring(0, 5)}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Equipment Requirements</h6>
                                                                        <p>{vehiclePref(items.vehiclePreferences)}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div>
                                                                        <h6>Comment</h6>
                                                                        <p title={items.comment}>{items.comment?.length > 30 ? (items.comment?.substring(0, 30).concat('...')) : (items.comment ? items.comment : 'NA')}</p>
                                                                    </div>
                                                                </td>
                                                                <td colspan="2">
                                                                    <div style={{ padding: '0px 20px 0px 0px', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap', gap: '10px' }}>
                                                                        {items?.specificationFile?.length !== 0 && items?.specificationFile?.map((spectItems, spectIndex) => (
                                                                            <div> {specificationFiles(spectItems)}</div>
                                                                        ))}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    }
                                                </>
                                            ))}
                                    </tbody>
                                </Table>
                            </OrderDetailsWrapper>

                            {finalData && finalData?.length === 0 &&
                                <p style={{ position: 'absolute', width: '90%', textAlign: 'center', marginTop: '40px' }}>No records found</p>
                            }

                            {finalData?.length !== 0 && <Pagination count={pageCount}
                                page={page + 1}
                                onChange={callFetchApiFunc} />}

                        </TableWrapper>
                    </div >
                    {notesModal && <Modal style={{ maxWidth: "972px" }} size="xl" isOpen={setNotesModal} centered={true}>
                        <NotesModalWrapper>
                            <ModalBody>
                                <NotesModal editResponse={editComment} editFlag={editFlag} toggle={(e) => {
                                    setNotesModal(false)
                                    callFetchApiFunc(e, page + 1)
                                }} />
                            </ModalBody>
                        </NotesModalWrapper>
                    </Modal>}

                    <YesNoModal
                        isOpen={yesNomodal}
                        toggle={yesNoToggleModal}
                        title=""
                        onClickHander={(val) => {
                            if (val === "no") {
                            } else {
                                markQuoteAction(selectedQuote)
                                setSelectedQuote("")
                            }
                        }}
                        content={yesNoModalContent}
                        link="/"
                    />
                    <AlertModal
                        isOpen={alertModal}
                        toggle={() => setAlertModal(!alertModal)}
                        content={alertModalContent}
                        alertType={alertType}
                        callBackAlert={(val, e) => {
                            if (val === "success") {
                                callFetchApiFunc(e, page + 1)
                                setAlertModal(false)
                            }
                        }}
                    />

                </div>
                :
                <p>You are not authorized to view this page.</p>
            }
        </>
    )
};

export default Quotes;

const UploadSpec = styled.div`    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
    span {
        white-space: normal;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    img {
      margin-right: 5px;
    }
`